import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { IButtonDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-profit-and-loss-vendor-not-supported-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, IButtonDirective, RouterLink],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="info"
      [title]="t('overlays.profit_and_loss_vendor_not_supported_title')"
    >
      <p overlayBody>{{ t("overlays.profit_and_loss_vendor_not_supported_reason") }}</p>
      <a overlayCta iButton variant="secondary" routerLink="/dashboard/advertising">
        {{ t("overlays.go_to_advertising_stats") }}
      </a>
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfitAndLossVendorNotSupportedOverlayComponent {
  static readonly rule = OverlayRule.PROFIT_AND_LOSS_VENDOR_NOT_SUPPORTED;
}
